import React from "react";
import { Input, Button } from "antd";
import { users } from '@services/api'

export default class AuthorizedPhoneItem extends React.Component{
    constructor(props) {
        super(props)
        this.state = {
            name: '',
            phone: ''
        }
    }

    componentDidMount() {
        const { item: { name, phone } } = this.props
        this.setState({ name, phone: `0${phone}` })
    }

    handleInput = (e) => {
        let value = e.target.value
        if (e.target.id === 'phone') {
            value = value.replace(/[^0-9\.]/g, '')
        }
        this.setState({ [e.target.id]: value })
    }

    submit = () => {
        const { name, phone } = this.state
        const {
            user_id,
            item: { id },
            getAuthorizedPhones,
            toggleEdit
        } = this.props

        const payload = {
            name,
            phone: phone,
            authorizedPhoneId: id
        }

        users.updateAuthorizedPhone(payload)
        .then(() => {
            getAuthorizedPhones(user_id)
            toggleEdit(null)
        })
        .catch((error) => { 
            let { errorCode } = error.response.data            
            alert(this.props.errorMsgs[errorCode] || 'העדכון נכשל')
        })
    }

    render() {
        const { name, phone } = this.state
        return (
            <div style={{ ...style.listItem }}>
                <div style={{ width: '30%' }}>
                    <Input style={{ width: '130px' }} id="name" value={name} onChange={this.handleInput}/>
                </div>
                <div style={{ width: '30%' }}>
                    <Input style={{ width: '130px' }} id="phone" value={phone}  onChange={this.handleInput}/>
                </div>
                <div style={{ width: '20%' }}>
                    <Button style={{ width: '65px' }} onClick={() => this.props.toggleEdit(null)}>{"ביטול"}</Button>
                </div>
                <div style={{ width: '20%', ...style.last }}>
                    <Button onClick={this.submit}>{"שמירה"}</Button>
                </div>
            </div>
        )
    }
}

const style = {
    listItem : {
        display: 'flex',
        justifyContent: 'space-between', 
        alignSelf: 'stretch',
        padding: '10px 10px 6px 0',
        border: 'solid #ad855f8f 1px',
        borderRadius: '4px'
    },
    last: {
        display: 'flex',
        justifyContent: 'end'
    }
}



